/** Settings → Help and its Community page. */
export default {
  whatsNew: "What's new",
  emailSupport: "Email support",
  sendFeedback: "Send feedback",
  reportAiContent: "Report inappropriate AI content",
  community: "Community",
  privacyPolicy: "Privacy policy",
  terms: "Terms",
  whatsappCommunity: "WhatsApp community",
} as const;
